/**
 * Recurrence defaults — a plain module, not part of RecurrenceEditor.jsx, so that
 * component file only default-exports a component (react-refresh/only-export-components).
 */

/** The browser's own zone: a schedule fires at the author's local wall time. */
export const localTz = () => {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC' } catch { return 'UTC' }
}

/**
 * Weekly-on-Monday-at-07:00 is the default because the overwhelmingly common ask
 * behind this feature is "have it waiting for me Monday morning".
 */
export const defaultRecurrence = () => ({
  freq: 'weekly',
  interval: 1,
  byDay: [1],
  byMonthDay: 1,
  hour: 7,
  minute: 0,
  tz: localTz(),
})

export const WEEKDAYS = [
  { v: 0, label: 'S', full: 'Sunday' },
  { v: 1, label: 'M', full: 'Monday' },
  { v: 2, label: 'T', full: 'Tuesday' },
  { v: 3, label: 'W', full: 'Wednesday' },
  { v: 4, label: 'T', full: 'Thursday' },
  { v: 5, label: 'F', full: 'Friday' },
  { v: 6, label: 'S', full: 'Saturday' },
]
